import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const externalLink = {
    college: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU3Njc0OTA1OQ==&scene=126&bizpsid=0#wechat_redirect',
    medical: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjc3MTU3NA==&scene=126&bizpsid=0#wechat_redirect',
    wehealth: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzMDY2OTk0Mg==&scene=126&bizpsid=0#wechat_redirect',
    bioInnovation: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg2OTM0MTg0MQ==&scene=124#wechat_redirect',
    recruit: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0MjA5MTIyMg==&scene=126&bizpsid=0#wechat_redirect',
    declaraction: 'http://www.medsci.cn/about/index.do?id=14'
};
const router = new VueRouter({
    routes: [{
        path: '/',
        component: () => import('@/views/home/index.vue'),
        meta: {
            title: '要闻快报'
        }
    }, {
        path: '/new',
        component: () => import('@/views/home/new.vue')
    }, {
        path: '/community',
        component: () => import('@/views/community/index.vue'),
        meta: {
            title: '基层与社区'
        }
    }, {
        path: '/website',
        component: () => import('@/views/website/index.vue'),
        meta: {
            title: '微官网'
        }
    }, {
        path: '/china',
        component: () => import('@/views/website/china.vue'),
        meta: {
            title: '微官网'
        }
    }, {
        path: '/groups',
        component: () => import('@/views/website/groups.vue'),
        meta: {
            title: '微官网'
        }
    }, {
        path: '/innovation',
        component: () => import('@/views/innovation/index.vue'),
        meta: {
            title: '创新研发'
        }
    }, {
        path: '/statement',
        component: () => import('@/views/statement/index.vue'),
        meta: {
            title: '微声明'
        }
    }, {
        path: '/statement/new_user',
        component: () => import('@/views/statement/new_user.vue'),
        meta: {
            title: '施维雅'
        }
    }, {
        path: '/production',
        component: () => import('@/views/production/index.vue'),
        meta: {
            title: '优质生产'
        }
    }, {
        path: '/chronic_disease',
        component: () => import('@/views/chronic_disease/index.vue'),
        meta: {
            title: '专注慢病'
        }
    }, {
        path: '/chronic_disease/list',
        component: () => import('@/views/chronic_disease/list.vue'),
        meta: {
            title: '专注慢病'
        }
    }, {
        path: '/oncology',
        component: () => import('@/views/tumour/index.vue'),
        meta: {
            title: '肿瘤领域关键参与者'
        }
    }, {
      path: '/oncology_pc',
      component: () => import('@/views/tumour/index_pc.vue'),
      meta: {
          title: '肿瘤领域关键参与者'
      }
    },
    {
        path:'/field',
        component:()=>import('@/views/field/index.vue'),
        meta:{
            title:'优势领域'
        }
    },
    {
        path:'/vein',
        component:()=>import('@/views/veindisease/index.vue'),
        meta:{
            title:'慢性静脉疾病'
        }
    }
  ]
});
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    let path = (to.path).substring(1);
    let arr = Object.keys(externalLink);
    if (arr.indexOf(path) != -1) {
        window.location.href = externalLink[path];
    }
    next();
})
export default router;
